<h2 mat-dialog-title>Element hinzufügen</h2>
<mat-dialog-content>
  <div class="space-y-2">
    @for (module of availableModules; track module; let i = $index) {
      <div
        class="flex items-center p-3 rounded-lg cursor-pointer transition-all duration-200 hover:bg-gray-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0"
        (click)="addModule(i)"
        >
        <div class="flex-shrink-0 mr-4">
          <img
            [src]="module.moduleDetails.previewImagePath"
            [alt]="module.moduleDetails.displayName"
            class="w-10 h-10 object-cover rounded border border-gray-200"
            />
        </div>
        <div class="flex items-center justify-between flex-grow">
          <span class="font-medium text-gray-700 text-sm">{{
            module.moduleDetails.displayName
          }}</span>
          <mat-icon class="text-blue-600 text-xl ml-2">add_circle</mat-icon>
        </div>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    Schließen
  </button>
</mat-dialog-actions>
